/**
 * Angular Imports.
 */
import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Service Imports
 */
import { DataStorageService } from './../../dataservices/data-storage.service';
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { FunCollectionService } from './../../common/common-functions/fun-collection.service';
import { PostApiService } from './../../dataservices/post-api.service';
import { MasterserviceService } from './../../dataservices/master-service/masterservice.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';

/**
 * Constant imports
 */
import { SCREEN_NAME, PRODUCT_TYPE_CONSTANT, GRADIENT_DIRECTION, EDITORS_DETAIL, NUMBERS, BOOKMARK_ACTION, CALLING_FROM, PRODUCT_TYPE_CONSTANT_NAME, ACTION_ON, ACTION_TYPE, CTA_TYPE } from '../../constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
import { CLICK } from 'analytics2.0/dist/core/constants/analytic.interface';
/**
 * Model Imports.
 */
import { HashTagSpecialty } from './../../interface/hashtag-specialty/hashtag-specialty.model';
import { Product, UserProfile } from './../../interface/editors-choice/editors-choice.model';
import { EcSlideCards } from './../../interface/editors-choice/editors-choice.model';
import { AnalyticsInterface } from '../../analytics-event/analytics.model';
import { ProfilePicImage } from '../../interface/userprofile/userprofile';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

import { Subscription } from 'rxjs';

/**
 * Editor choice detail card component
 */
@Component({
  selector: 'app-editor-choice-detail-card',
  templateUrl: './editor-choice-detail-card.component.html',
  styleUrls: ['./editor-choice-detail-card.component.scss']
})
export class EditorChoiceDetailCardComponent implements OnInit, OnDestroy {
  /**
   * Output is used to emit editor choice specialty in card.
   */
  @Output() feedSpecialty: EventEmitter<HashTagSpecialty> = new EventEmitter<HashTagSpecialty>();
  /**
   * Input is used to for importing ec_products.
   */
  @Input() ec_products: EcSlideCards[];
  /**
   * Input is used to for importing product.
   */
  @Input() product: Product;
  /**
   *Input is used to for importing editorTextHighlight.
   */
  @Input() editorTextHighlight: string;

  /**
  * input for profile_left_pic_image
  */
  @Input() profile_pic_image: ProfilePicImage;

  /**
   * input for profile
   */
  @Input() profile: UserProfile;

  /**
   * Constant for product type
   */
  public productType = PRODUCT_TYPE_CONSTANT;

  /**
   * Gradient direction constant
   *
   * @memberof EditorChoiceDetailCardComponent
   */
  public gradientDirection = GRADIENT_DIRECTION;
  /**
   * Key used to store selected specialty name.
   */
  public selectedSpecialty: string;
  /**
   * Constant for string editors_detail.
   */
  public editorChoice = EDITORS_DETAIL.EC_DETAIL;

  /**
   * Used to store calling fro constant value.
   */
  public callingFrom = CALLING_FROM;

  /**
   * constant for NUMBERS
   */
  public numbers = NUMBERS;

  /**
   *
   * bookmark loader
   */
  public ec_bookmark_loader = false;

  /**
   * Holds all the subscription
   */
  private subscriptions: Subscription = new Subscription();
  /**
   * Analytics var for tag specilixation click.
   */
  public analyticsTagSpecilizationData: AnalyticsInterface;
  /**
   * Session time for analytics.
   */
  public sessiontime = { 'start_time': '', 'end_time': '' };

  /**
   * Analytics ec bookmark event.
   */
  public analyticsBookmarkData: AnalyticsInterface;

  /**
   * Necessary instance.
   */
  constructor(
    private dss: DataStorageService,
    private router: Router,
    private masterService: MasterserviceService,
    private postService: PostApiService,
    private fnCollectionService: FunCollectionService,
    private jwtSer: JwtDecodeService,
    public mls: NewLanguageService,
    private analyticSdk: Analytics
  ) {

  }

  ngOnInit(): void {
    /**
     * Analytics object.
     */
    this.analyticsBookmarkData = {
      'event_name': EVENT_NAME.FEED_BOOKMARK_CLICK,
      'product_type': this.productType.EDITORS_CHOICE,
      'product_type_id': this.product.product_type_id,
      'screen_name': SCREEN_NAME.EC_DETAIL,
    };
  }

  /**
   * Method for getting specialty
   */
  getSpecialty(specialty): void {
    this.feedSpecialty.emit(specialty);
    this.dss.specialty_filter = specialty;
    this.router.navigate(['/web/list']);

    const dateObject = new Date();
    this.sessiontime.start_time = dateObject.getTime().toString();
    /**
     * Set analyics data on ngDestroy.
     */
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.INSIGHT_COLLECTOR,this.product.product_type_id, SCREEN_NAME.EC_DETAIL, CTA_TYPE.TEXT, ACTION_TYPE.CLICK, ACTION_ON.SPECIALITY_HASTAG, null);
  }
  /**
   * Feed specialty from feed post card.
   */
  feedListFilteredBySpecialty(specialty): void {
    this.selectedSpecialty =
      specialty.speciality_name || specialty.category_name;
    const specialtyVal =
      [{
        key: 'speciality',
        value: [specialty.speciality_id || specialty.category_id]
      }];
    this.dss.feed_filter.next(specialtyVal);
  }
  /**
   * Method for routing to detail page
   */
  detailPage(): void {
    this.router.navigate(['editor-choice']);
  }

  /**
   * product Bookmark
   */
  productBookmark(): boolean {
    if (this.masterService.isOnline === false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    if (this.ec_bookmark_loader) {
      return;
    }
    this.ec_bookmark_loader = true;
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.INSIGHT_COLLECTOR,this.product.product_type_id, SCREEN_NAME.EC_DETAIL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.BOOKMARK, null);
    const action = (this.product.is_bookmarked === NUMBERS.ZERO) ? BOOKMARK_ACTION.ADD : BOOKMARK_ACTION.DELETE;
    const bookmarkSubscription = this.postService.productBookmark(PRODUCT_TYPE_CONSTANT.EDITORS_CHOICE,
      this.product.product_type_id, action).subscribe(resData => {
        this.ec_bookmark_loader = false;
        this.jwtSer.decodeData(resData).then(data => {
          if (data['status'] === NUMBERS.ONE) {
            this.fnCollectionService.showSuccess(data['msg'], 'Success');
            this.product.is_bookmarked = (action === BOOKMARK_ACTION.ADD) ? NUMBERS.ONE : NUMBERS.ZERO;
          } else if (data['status'] === NUMBERS.ZERO) {
            this.fnCollectionService.showError(data['msg'], 'Error');
            this.fnCollectionService.errorHandeler(data);
            this.ec_bookmark_loader = false;
            return;
          }
        }, () => {
          this.ec_bookmark_loader = false;
        });
      });
    this.subscriptions.add(bookmarkSubscription);
  }

  /**
   * navigate to user profile
   */
  navigateToProfile(): void {
    if (this.profile.custom_id) {
      this.fnCollectionService.navigateToUserProfie(this.profile.custom_id);
    }
  }

  /**
   * Called once, before the instance is destro
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
